//axiosInstance.js
//导入axios
import axios from 'axios';

//使用axios下面的create([config])方法创建axios实例，其中config参数为axios最基本的配置信息。
const service  = axios.create({
	baseURL: "/api",	//请求后端数据的基本地址，自定义
	timeout: 30000 ,     //请求超时设置，单位ms
  maxRedirects: 0,
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
})

//导出我们建立的axios实例模块，ES6 export用法
export function API(config) {
  // 关键：必须 return 这个 Promise
  return service(config);
}
//export default service;
